import {
  CLEAN_UP_BUGS_SUCCESS,
  CLOSE_QUOTE_EXTEND_CLOSING_DATE_DIALOG,
  EXTEND_QUOTE_CLOSING_DATE,
  EXTEND_QUOTE_CLOSING_DATE_ERROR,
  EXTEND_QUOTE_CLOSING_DATE_SUCCESS,
  OPEN_QUOTE_EXTEND_CLOSING_DATE_DIALOG,
  RESET_CHANGE_DATE_CLOSE_SUCCESS
} from './ExtendQuoteClosingDateDialog.actions'

const extendQuoteClosingDateDialogState = {
  changeDateClose: false,
  code: undefined,
  errors: [],
  loading: false,
  open: false
}

/**
 * The Extend Quote Closing Date Dialog reducer.
 */
const extendQuoteClosingDateDialogReducer = (state = extendQuoteClosingDateDialogState, { payload, type }) => {
  switch (type) {
    case CLEAN_UP_BUGS_SUCCESS: {
      return { ...state, errors: extendQuoteClosingDateDialogState.errors }
    }
    case CLOSE_QUOTE_EXTEND_CLOSING_DATE_DIALOG: {
      return { ...state, open: false, code: extendQuoteClosingDateDialogState.code }
    }
    case EXTEND_QUOTE_CLOSING_DATE: {
      return { ...state, errors: [], loading: true }
    }
    case EXTEND_QUOTE_CLOSING_DATE_ERROR: {
      return { ...state, errors: payload.errors, loading: false }
    }
    case EXTEND_QUOTE_CLOSING_DATE_SUCCESS: {
      return { ...state, changeDateClose: payload.data, errors: [], loading: false, open: false }
    }
    case OPEN_QUOTE_EXTEND_CLOSING_DATE_DIALOG: {
      return { ...state, open: true, code: payload.code }
    }
    case RESET_CHANGE_DATE_CLOSE_SUCCESS: {
      return { ...state, changeDateClose: extendQuoteClosingDateDialogState.changeDateClose }
    }
    default: {
      return state
    }
  }
}

export default extendQuoteClosingDateDialogReducer
